<template>
  <div class="ui left aligned container">
    <div class="ui container flex">
      <a href="https://m.v.qq.com/app/activity/sports/index.html?&actId=8262942" target="_blank">《超新星2》场内应援</a>
      <a href="https://sports.qq.com/mkbsapp/yuanqi.htm#/" target="_blank">《超新星2》元气助力</a>
      <button @click="refresh()" class="ui right aligned primary mini button" id="refresh"><i class="sync icon"></i>
      </button>
    </div>
    <vuetable ref="vuetable"
              api-url="/bearers"
              :fields="fields"
    >
    </vuetable>
    <div class="ui form">
      <div class="inline fields">
        <label>间隔</label>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="5" v-model="interval" @change="load()">
            <label>5分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="15" v-model="interval" @change="load()">
            <label>15分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="30" v-model="interval" @change="load()">
            <label>30分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="60" v-model="interval" @change="load()">
            <label>60分钟</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="180" v-model="interval" @change="load()">
            <label>3小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="360" v-model="interval" @change="load()">
            <label>6小时</label>
          </div>
        </div>
        <div class="field">
          <div class="ui radio checkbox">
            <input type="radio" name="interval" value="720" v-model="interval" @change="load()">
            <label>12小时</label>
          </div>
        </div>
      </div>
    </div>
    <v-chart id="chart2" :options="options2" theme="light"></v-chart>
    <v-chart id="chart1" :options="options1" theme="light"></v-chart>
    <br>
  </div>
</template>
<style>
  .ui.container.flex {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }
  #chart1, #chart2 {
    width: 800px;
  }
</style>
<script>
  import axios from 'axios';
  import ECharts from 'vue-echarts';
  import Vuetable from '../table/Vuetable.vue';

  export default {
    name: 'BearerList',
    components: {
      Vuetable,
      'v-chart': ECharts
    },
    data() {
      return {
        interval: 5,
        options1: null,
        options2: null,
        time: '',
        curPeriod: '',
        fields: [
          {name: 'name', title: '姓名', callback: 'link', sortField: 'id'},
          {name: 'rank', title: '应援排名', sortField: 'rank'},
          {name: 'voteCnt', title: '应援票数', sortField: 'rank'},
          {name: 'position', title: '元气排名', sortField: 'position'},
          {name: 'voteNum', title: '元气票数', sortField: 'position'},
        ]
      };
    },
    mounted() {
      this.load();
    },
    methods: {
      refresh: function () {
        this.$refs.vuetable.reload();
      },
      load: function () {
        axios.get('/bearers/chart?count=8&interval=' + this.interval).then(data => {
          let series = [];
          let legend = [];
          for (let item of data.data) {
            let name = item[0].name;
            series.push({
              name: name,
              type: 'line',
              data: item.map(e => [e.time, e.inc1])
            });
            legend.push(name);
          }
          this.options1 =
            {
              title: {
                text: '应援增幅'
              },
              legend: {
                data: legend
              },
              tooltip: {
                trigger: 'axis'
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'time'
              },
              yAxis: {
                type: 'value'
              },
              series: series
            };

          series = [];
          legend = [];
          for (let item of data.data) {
            let name = item[0].name;
            series.push({
              name: name,
              type: 'line',
              data: item.map(e => [e.time, e.inc2])
            });
            legend.push(name);
          }
          this.options2 =
            {
              title: {
                text: '元气增幅'
              },
              legend: {
                data: legend
              },
              tooltip: {
                trigger: 'axis'
              },
              toolbox: {
                feature: {
                  saveAsImage: {}
                }
              },
              xAxis: {
                type: 'time'
              },
              yAxis: {
                type: 'value'
              },
              series: series
            };
        });
      },
      link: function (value, item) {
        return '<a href="#/sport/' + item.userId + '">' + value + '</a>';
      },
      rankStatus: function (value) {
        if (value > 0) {
          return '↑';
        }
        if (value < 0) {
          return '↓';
        }
        return '-';
      }
    }
  };
</script>
